import { useCallback } from 'react';

import { LIFECYCLE, useLifecycle } from '@sorare/core/src/hooks/useLifecycle';

export const useDismissFirstTime = () => {
  const { update, loading, lifecycle } = useLifecycle();

  const hasDismissed = lifecycle?.sawForYouFirstTime;

  const dismiss = useCallback(async () => {
    if (loading) return null;
    return update(LIFECYCLE.sawForYouFirstTime, true);
  }, [loading, update]);

  return {
    hasDismissed,
    dismiss,
  };
};
